import React, { useEffect, useRef, useState } from 'react'
import { Header } from '../Core/Header'
import { Footer } from '../Core/Footer'
import { editProfileApi, getCustomizedBooking, getCustomizeTestReport, getInvoice, getOrderHistory, getProducts, getProfile, getServiceHistory, getSupportMessage, getWishlist, mySupportMessage, replySupportMessage, sendSupportMessage } from '../Services/Operations/ProductAPI'
import { useNavigate } from 'react-router'
import Cookies from "js-cookie";
import { toast } from 'react-toastify'
import { baseURL } from '../Services/api_endpoints'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ProductCard from '../Core/ProductCard'




const Editprofile=()=>{

  const[firstName,setFirstName] = useState("")
const[middleName,setMiddleName] = useState("")
const[lastName,setLastName] = useState("")
const[email,setEmail] = useState("")
const[primaryPhone,setPrimaryPhone] = useState("")
const [image,setImage]=useState(null)
const [selectedImage, setSelectedImage] = useState(null);
const fileInputRef = useRef(null);
const[referralsList,setReferralsList]=useState([])

 const handleClick = () => {
    fileInputRef.current.click(); // trigger hidden file input
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
     setSelectedImage(e.target.files[0]); // store in state
      console.log("Selected file:", e.target.files[0]);
    }
  };


const fetchProfileData=async()=>{
  try {
    const response=await getProfile()
    console.log("Profile Data:", response);
    setFirstName(response.data.data.patientName || "");
    setMiddleName(response.data.user.middleName || "");
    setLastName(response.data.user.lastName || "");
    setEmail(response.data.data.patientEmail || "");
    setPrimaryPhone(response.data.data.patientMobile || "");
    setImage(response.data.user.profileImage||"")
    setReferralsList(response.data.data.referredByList)
    
  } catch (error) {
    console.error("Error fetching profile data:", error);

  }
}

const handerlUpdateProfile=async()=>{
  try {
    const data=new FormData()
    // const data={
    //   firstName,middleName,lastName,email,primaryPhone
    // }
    data.append("firstName",firstName)
    data.append("middleName",middleName)
    data.append("lastName",lastName)
    data.append("email",email)
    data.append("primaryPhone",primaryPhone)

    if(selectedImage){
    data.append("profileImageFile",selectedImage)
    }

    console.log(data);
    const response=await editProfileApi(data)
    console.log(response);
    if(response.status===200){
      fetchProfileData()
      toast.success("Profile updated successfully !")
      return
    }
    
    
    
  } catch (error) {
    console.log(error);
    
  }
}



useEffect(() => {
  
  fetchProfileData()
 
}, [])

    return(
        <div className='flex flex-col items-center' style={{height:"100%",width:"100%",overflowY:"auto"}}>
            <h1 className='text-md'>View & Update your personal and contact information</h1>

            <div className='w-full h-full p-4 flex flex-col items-start justify-center gap-1 shadow-lg mb-2 rounded-md'
            style={{overflowY:"scroll"}}>
            <p>Personal Information</p>

      <div style={{position:"relative"}}>
        <img src={selectedImage?URL.createObjectURL(selectedImage): baseURL+image}
        style={{height:"100px",width:"100px",borderRadius:"50%"}}
        />

        <p 
        style={{padding:"4px",backgroundColor:"#7eb9fdff",width:"fit-content",cursor:"pointer",
          borderRadius:"8px",color:"#000000",position:"absolute",right:"1px",bottom:"5px",fontSize:"6px"}}
        onClick={handleClick}
        >
          <img src='/Assets/img/camera.png' style={{width:"12px"}}/>
        </p>


          <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      </div>

            <div className='w-full h-fit flex items-start gap-2 justify-between'>
                
                <p>First name :<input value={firstName} onChange={(e)=>setFirstName(e.target.value)}/></p>
                <p>Middle name :<input value={middleName} onChange={(e)=>setMiddleName(e.target.value)}/></p>
                <p>Last name :<input value={lastName} onChange={(e)=>setLastName(e.target.value)}/></p>
                
            </div>
            <p>Contact Information</p>
            <div className='w-full h-fit flex items-start gap-2 justify-between'>
                
                <p>Email:<input value={email} onChange={(e)=>setEmail(e.target.value)}/></p>
                <p>Primary Phone:<input value={primaryPhone} onChange={(e)=>setPrimaryPhone(e.target.value)}/></p>
                
            </div>
             <p>Refferal Information</p>
              {
                referralsList.map((item,ind)=>(
                  <div style={{display:"flex",gap:"30px"}}>
                    
                    <p>{item.referredByName}</p>
                    <p style={{fontSize:"14px"}}>({item.remarks})</p>
                    </div>
                ))
              }

            </div>

            <p className='p-2 rounded-lg bg-blue-800 text-white w-fit text-center cursor-pointer'
            onClick={handerlUpdateProfile}
            >
              Edit Profile</p>
        </div>
    )
}

const OrderHistory=()=>{

  const ORDER_STATUSES = [
  "CREATED",
  "CONFIRMED",
  "PICKUP",
  "DISPATCHED",
  "DELIVERED"
];



const OrderTracking = ({ currentStatus }) => {
  const currentIndex = ORDER_STATUSES.indexOf(currentStatus);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px",
        maxWidth: "900px",
        margin: "auto"
      }}
    >
      {ORDER_STATUSES.map((status, index) => {
        const isCompleted = index < currentIndex;
        const isActive = index === currentIndex;

        return (
          <div
            key={status}
            style={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              position: "relative"
            }}
          >
            {/* Circle */}
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: isCompleted
                  ? "#28a745"
                  : isActive
                  ? "#007bff"
                  : "#cccccc",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                zIndex: 2
              }}
            >
              {isCompleted ? "✓" : index + 1}
            </div>

            {/* Status Text */}
            <div
              style={{
                position: "absolute",
                top: "45px",
                width: "100px",
                left: "-32px",
                textAlign: "center",
                fontSize: "12px",
                fontWeight: isActive ? "600" : "400"
              }}
            >
              {status}
            </div>

            {/* Line */}
            {index !== ORDER_STATUSES.length - 1 && (
              <div
                style={{
                  height: "4px",
                  flex: 1,
                  margin: "0 6px",
                  backgroundColor: isCompleted ? "#28a745" : "#cccccc",
                  zIndex: 1
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};


    const divRef = useRef();
const[mobile,setmobile]=useState(window.innerWidth<560)
  const [orderList,setOrderList]=useState([])
  const [viewModal,setViewModal]=useState(null)
   const [supportSelectModal,setSupportSelectModal]=useState(null)
  const[hover,setHover]=useState(-1)
  const [invoice,setInvoice]=useState(null)
  const[invoiceData,setInvoiceData]=useState(null)
  const [supportProduct,setSupportProduct]=useState(null)
  const[supportCheckoutid,setSupportCheckoutId]=useState(0)
  const[currentSupport,setCurrentSupport]=useState(0)
  const [supportBox,setSupportBox]=useState(false)
  const[supportMessage,setSupportMessage]=useState("")
  const[supportMessages,setSupportMessages]=useState([])


  const fetchOrderHistory=async()=>{
    try {
      const response=await getOrderHistory()
      console.log("orders",response);
      if(response.status===200){
        setOrderList(response.data)
        return
      }
      
    } catch (error) {
      console.log(error);
      
    }
   }
   const handlerGetInvoice=async(id)=>{
    setInvoice(id)
    try {
      const response=await getInvoice(id)
      console.log(response);
      if(response.status===200){
        setInvoiceData(response.data)
      }
      
    } catch (error) {
      console.log(error);
      
    }
   }

   function formatTimestamp(ms) {
    const date = new Date(ms);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months start at 0
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
}
   

   useEffect(() => {
     fetchOrderHistory()
     getSupportMessages()
     

   }, [])
   useEffect(() => {
     handleMySupportMessages()
   }, [supportProduct])
   

   const timeConvert=(timestamps)=>{
    const date = new Date(timestamps);

// Format to readable string
const readableDate = date.toLocaleString();

return readableDate
   }

 const handleDownloadInvoice = async () => {
    const input = divRef.current;

    // Capture the div as a canvas
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // Calculate image height in PDF width
    const imgProps = {
      width: pdfWidth,
      height: (canvas.height * pdfWidth) / canvas.width,
    };

    let heightLeft = imgProps.height;
    let position = 0;

    // Add first page
    pdf.addImage(imgData, "PNG", 0, position, imgProps.width, imgProps.height);
    heightLeft -= pdfHeight;

    // Add more pages if needed
    while (heightLeft > 0) {
      position = heightLeft - imgProps.height;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgProps.width, imgProps.height);
      heightLeft -= pdfHeight;
    }

    pdf.save("invoice.pdf");
  };

  const handleSendSupportMessage=async()=>{
    try {
      let data={
        productId:supportProduct.productId,
        checkoutId:supportCheckoutid,
        supportType: "TECHNICAL_SUPPORT",
        message: supportMessage,
        
      }
      const response=await sendSupportMessage(data)
      console.log(data);
      console.log(response);
      if(response.status===200){
        setSupportMessage("")
         handleMySupportMessages()
        
      }
      
      
    } catch (error) {
      console.log(error);
      
    }
  }
   const handleReplySupportMessage=async()=>{
    try {
      let data={
        
        message: supportMessage,
          supportId: currentSupport,
        
      }
      const response=await replySupportMessage(data)
      console.log(data);
      console.log(response);
      if(response.status===200){
        setSupportMessage("")
         handleMySupportMessages()
        
      }
      
      
    } catch (error) {
      console.log(error);
      
    }
  }

  const getSupportMessages=async()=>{
    try {
      const response=await getSupportMessage(3)
      console.log(response);
      
    } catch (error) {
      console.log(error);
      
    }
  }

   const handleMySupportMessages=async()=>{
    try {
      const response=await mySupportMessage()
      console.log(response);
      if(response.status===200){
        const list=response.data.find(i=>i.checkoutId===supportCheckoutid && i.productId===supportProduct.productId)
          if(list){
            console.log("support",list?.supportId);
            
            setCurrentSupport(list?.supportId)
          const response1=await getSupportMessage(list.supportId)
          console.log("list",response1);
           setSupportMessages(response1.data)
          }
        
          
        
       
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }
   

    return(
        <div>
            <h1 className='text-md'>View your order history</h1>
           

            <div className='w-full h-[460px]  p-1 flex flex-wrap items-start justify-start gap-6 shadow-lg mb-2 rounded-md'
            style={{overflowY:"auto",overflowX:"visible"}}
            >
     
          <table   className="table table-hover table-vcenter table-striped mb-0 text-nowrap"
          >
      
          <thead>
            <tr >
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Id</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Total paid</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Date</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Status</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Mode</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Address</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Pin Code</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Total products</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Invoice</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Support</th>
             <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>View</th>
          </tr>
          </thead>
          <tbody>
            {
              orderList.map((item,indx)=>(
              <tr className='hover:bg-gray'
              style={{padding:"4px", transition: "transform 0.2s ease-in-out",color:"black",
                zIndex:999,cursor:"pointer",border:"0.3px solid black",minWidth:"fit-content",
              backgroundColor:hover===indx?"#8f8e8eff":"#fefefe",color:hover===indx?"white":"black",
              fontSize:"12px"
              }}
                 onMouseEnter={e => {(e.currentTarget.style.transform = "scale(1.01)"); setHover(indx)}}
           onMouseLeave={e => {(e.currentTarget.style.transform = "scale(1)");setHover(-1)}}
              >
              <th style={{textAlign:"center",maxWidth:"100px",overflow:"auto",border:"0.3px solid black"}}>{indx+1}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>₹{item.grandTotal}</th>
              <th style={{textAlign:"center",maxWidth:"170px",overflow:"hidden",border:"0.3px solid black"}}>{timeConvert(item.createdAt)}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.paymentStatus}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.paymentMode}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.address}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.pincode}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.items.length}</th>
                 <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black",borderRadius:"8px"}}
                 onClick={()=>handlerGetInvoice(item.checkoutId)}>Get invioce</th>
                  <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}
                  onClick={()=>setSupportSelectModal(item)}>
                    <img src='/Assets/img/customer-service.png' style={{width:"25px"}}/>
                  </th>
              
              <th style={{textAlign:"center", blackmaxWidth:"130px",overflow:"hidden"}}>
                <img src='/Assets/img/eye.png' style={{width:"18px"}}
                onClick={()=>setViewModal(item)}
                />
                </th>
            </tr>
              ))
            }
           
          </tbody>
       
       </table>
       {
              viewModal &&
              <div style={{width:mobile?"350px":"450px",borderCollapse: "collapse",border:"1px solid gray",backgroundColor:'white',borderRadius:"10px",padding:"10px"
          ,boxShadow: "0 2px 8px rgba(0,0,0,0.1)",position:"absolute",top:"200px",right:"10vw",zIndex:99999,color:"black",}}>
                <p style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                  <span>Products of this order  ({viewModal?.items.length})</span>
                  <span onClick={()=>setViewModal(null)}
                    style={{cursor:"pointer"}}
                    >X</span>
                </p>
                <div style={{width:"100%",height:"fit-content",overflow:"auto",border:"0.3px solid #cecccc",borderRadius:"10px",padding:"10px",fontSize:"14px"}}>
                  Courier Partner:
                  <p style={{fontWeight:"750"}}>{viewModal.courierName}</p>
                  </div>

                <div style={{width:"100%",maxHeight:"70vh",height:"fit-content",overflow:"auto"}}>
                  {
                    viewModal?.items.map((item,indx)=>(
                      <div style={{padding:"10px",borderRadius:"8px",backgroundColor: "#fff",margin:"10px",
                     boxShadow: "0 10px 25px rgba(0, 0, 0, 0.5)",  transition: "transform 0.5s ease-in-out"
                      }}
                              onMouseEnter={e => {(e.currentTarget.style.transform = "scale(1.05)")}}
           onMouseLeave={e => {(e.currentTarget.style.transform = "scale(1)")}}
                      >
                        <div style={{display:"flex",alignItems:"start",justifyContent:"left",gap:"20px"}}>
                         <img src={baseURL+item.productImage}
                         style={{width:"50px",borderRadius:"50%"}}
                         />
                        
                        <p style={{fontSize:"22px",fontWeight:"600"}}>{item.productName}</p>
                         
                        </div>
                        <div style={{display:"flex",alignItems:"start",justifyContent:"left",gap:"20px"}}>
                        <p>Total: {item.totalPrice}</p>
                        <p>Sale Price: {item.salePrice}</p>
                        <p>Quantity: {item.quantity}</p>
                        </div>
                      
                      </div>
                    ))
                  }

                </div>

                

                <OrderTracking currentStatus={viewModal.orderStatus} />

              </div>
            }

             {
              supportSelectModal &&
              <div style={{width:"450px",borderCollapse: "collapse",border:"1px solid gray",backgroundColor:'white',borderRadius:"10px",padding:"10px"
          ,boxShadow: "0 2px 8px rgba(0,0,0,0.1)",position:"absolute",top:"200px",right:"10vw",zIndex:99999,color:"black",}}>
                <p style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                  <span>Select a product  ({viewModal?.items.length})</span>
                  <span onClick={()=>setSupportSelectModal(null)}
                    style={{cursor:"pointer"}}
                    >X</span>
                </p>

                <div style={{width:"100%",maxHeight:"70vh",height:"fit-content",overflow:"auto"}}>
                  {
                    supportSelectModal?.items.map((item,indx)=>(
                      <div style={{padding:"10px",borderRadius:"8px",backgroundColor: "#fff",margin:"10px",
                     boxShadow: "0 10px 25px rgba(0, 0, 0, 0.5)",  transition: "transform 0.5s ease-in-out"
                      }}
                              onMouseEnter={e => {(e.currentTarget.style.transform = "scale(1.05)")}}
           onMouseLeave={e => {(e.currentTarget.style.transform = "scale(1)")}}
                     onClick={()=>{setSupportProduct(item);setSupportCheckoutId(supportSelectModal.checkoutId);
                      setSupportBox(true);setSupportSelectModal(null)
                     }}
                     >
                        <div style={{display:"flex",alignItems:"start",justifyContent:"left",gap:"20px"}}>
                         <img src={baseURL+item.productImage}
                         style={{width:"50px",borderRadius:"50%"}}
                         />
                        
                        <p style={{fontSize:"22px",fontWeight:"600"}}>{item.productName}</p>
                         
                        </div>
                       
                      
                      </div>
                    ))
                  }

                </div>

              </div>
            }

            {
              supportBox &&
                  <div style={{width:"350px",borderCollapse: "collapse",border:"1px solid gray",backgroundColor:'white',borderRadius:"10px",padding:"10px"
          ,boxShadow: "0 2px 8px rgba(0,0,0,0.1)",position:"absolute",top:"200px",right:"10vw",zIndex:99999,color:"black",}}>
                <p style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                  <span>Select a product  ({viewModal?.items.length})</span>
                  <span onClick={()=>setSupportBox(false)}
                    style={{cursor:"pointer"}}
                    >X</span>
                </p>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <p>Checkout id: {supportCheckoutid}</p>
                <p>Product id: {supportProduct.productId}</p>
                </div>

                <div style={{border:"1px solid grey",borderRadius:"10px",margin:"16px",
                  width:"300px",height:"300px",overflowY:"scroll"
                }}>
                  {
                    supportMessages.map((chat)=><p>
                      {chat.message}
                    </p>)
                  }
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",gap:"10px"}}>
                    <textarea
                    value={supportMessage}
                    onChange={(e)=>setSupportMessage(e.target.value)}
                    placeholder='Write messages...'
                    style={{width:"90%",padding:"5px",outline:"none",border:"1px solid grey"}}
                    ></textarea>
                    <p style={{cursor:"pointer",backgroundColor:"black",padding:'4px',color:"white"}}
                    onClick={()=>currentSupport===0? handleSendSupportMessage():handleReplySupportMessage()}>send</p>
                    </div>
                </div>
            }

            {
              invoice && 
              <div style={{width:"350px",borderCollapse: "collapse",border:"1px solid gray",backgroundColor:'white',borderRadius:"10px",padding:"10px"
          ,boxShadow: "0 2px 8px rgba(0,0,0,0.1)",position:"absolute",top:"200px",right:"10vw",zIndex:99999,color:"black",}}>
                <p style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                <span style={{cursor:"pointer",padding:"6px",color:"white",backgroundColor:"#041f04",borderRadius:"8px"}}
                onClick={handleDownloadInvoice}>download</span>
                  <span onClick={()=>setInvoice(null)}
                    style={{cursor:"pointer"}}
                    >X</span>
                </p>
                <div style={{width:"100%",height:"100%",borderRadius:"10px",border:"0.3px solid grey",padding:"10px",position:"relative",display:"flex",flexDirection:"column"}}
                ref={divRef}>
                 <img src="Assets/LogoRndsan.jpeg" width="170px" />
                <p style={{fontSize:"14px",marginBottom:0}}> Chakdaha,Nadia,West Bengal,741248</p>
                <p style={{fontSize:"14px",marginBottom:0}}> contact@rndsan.com</p>
                <hr/>
                  <p style={{textAlign:"center",fontSize:"14px"}}>{timeConvert(invoiceData?.createdAt)}</p>
                  <hr/>
                  <p>Order Address: {invoiceData?.city}, {invoiceData?.state}, {invoiceData?.pincode}</p>
                  <hr/>
                  {
                    invoiceData?.items.map((item)=>(
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <p>{item.quantity}x</p>
                        <img src={item.productImage}
                        style={{width:"15px",height:"15px",borderRadius:"50%"}}/>
                        <p>{item.productName}</p>
                        <p>₹{item.totalPrice}</p>
                        </div>
                    ))
                  }
                  <hr/>
                  <p style={{display:"flex",justifyContent:'space-between'}}>
                    <span>Sub Amount :</span>
                  <span>₹{Number(invoiceData?.totalAmount).toFixed(2)}</span></p>
                  <p style={{color:invoiceData?.paymentStatus==='PAID'?"green":'red'}}>
                    {invoiceData?.paymentStatus==='PAID'?"Paid":"Unpaid"}({invoiceData?.paymentMode})</p>
                
                  <p style={{display:"flex",justifyContent:'space-between'}}>
                    <span>Total Price :</span>
                  <span>₹{Number(invoiceData?.grandTotal).toFixed(2)}</span></p>
                </div>
                </div>
            }
       
            </div>

            
            
        </div>
    )

}

const ServiceHistory=()=>{

  const [orderList,setOrderList]=useState([])
  const [viewModal,setViewModal]=useState(null)
  const[hover,setHover]=useState(-1)

  const fetchServiceHistory=async()=>{
    try {
      const response=await getServiceHistory()
      console.log("getServiceHistory",response);
      if(response.status===200){
        setOrderList(response.data)
        return
      }
      
    } catch (error) {
      console.log(error);
      
    }
   }
   

   useEffect(() => {
     fetchServiceHistory()

   }, [])

   const timeConvert=(timestamps)=>{
    const date = new Date(timestamps);

// Format to readable string
const readableDate = date.toLocaleString();

return readableDate
   }
   

    return(
        <div>
            <h1 className='text-md'>View your order history</h1>
           

            <div className='w-full h-[460px]  p-1 flex flex-wrap items-start justify-start gap-6 shadow-lg mb-2 rounded-md'
            style={{overflowY:"auto",overflowX:"visible"}}
            >
     
          <table   className="table table-hover table-vcenter table-striped mb-0 text-nowrap"
          >
      
          <thead>
            <tr >
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Id</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>productName</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>pickupLocation</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>serialNumber</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>serviceStatus</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>pickupDateTime</th>
               <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>bookedBy</th>

          </tr>
          </thead>
          <tbody>
            {
              orderList.map((item,indx)=>(
              <tr className='hover:bg-gray'
              style={{padding:"4px", transition: "transform 0.2s ease-in-out",color:"black",
                zIndex:999,cursor:"pointer",border:"0.3px solid black",minWidth:"fit-content",
              backgroundColor:hover===indx?"#8f8e8eff":"#fefefe",color:hover===indx?"white":"black"
              }}
                 onMouseEnter={e => {(e.currentTarget.style.transform = "scale(1.01)"); setHover(indx)}}
           onMouseLeave={e => {(e.currentTarget.style.transform = "scale(1)");setHover(-1)}}
              >
              <th style={{textAlign:"center",maxWidth:"100px",overflow:"auto",border:"0.3px solid black"}}>{indx+1}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.productName}</th>
              <th style={{textAlign:"center",maxWidth:"170px",overflow:"hidden",border:"0.3px solid black"}}>{item.pickupLocation}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.serialNumber}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.serviceStatus}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.pickupDateTime[0]}/{item.pickupDateTime[1]}/{item.pickupDateTime[2]}</th>
               <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.bookedBy}</th>
            </tr>
              ))
            }
           
          </tbody>
       
       </table>
       {
              viewModal &&
              <div style={{width:"450px",borderCollapse: "collapse",border:"1px solid gray",backgroundColor:'white',borderRadius:"10px",padding:"10px"
          ,boxShadow: "0 2px 8px rgba(0,0,0,0.1)",position:"absolute",top:"200px",right:"10vw",zIndex:99999,color:"black",}}>
                <p style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                  <span>Products of this order  ({viewModal?.items.length})</span>
                  <span onClick={()=>setViewModal(null)}
                    style={{cursor:"pointer"}}
                    >X</span>
                </p>

                <div style={{width:"100%",maxHeight:"70vh",height:"fit-content",overflow:"auto"}}>
                  {
                    viewModal?.items.map((item,indx)=>(
                      <div style={{padding:"10px",borderRadius:"8px",backgroundColor: "#fff",margin:"10px",
                     boxShadow: "0 10px 25px rgba(0, 0, 0, 0.5)",  transition: "transform 0.5s ease-in-out"
                      }}
                              onMouseEnter={e => {(e.currentTarget.style.transform = "scale(1.05)")}}
           onMouseLeave={e => {(e.currentTarget.style.transform = "scale(1)")}}
                      >
                        <div style={{display:"flex",alignItems:"start",justifyContent:"left",gap:"20px"}}>
                         <img src={baseURL+item.productImage}
                         style={{width:"50px",borderRadius:"50%"}}
                         />
                        
                        <p style={{fontSize:"22px",fontWeight:"600"}}>{item.productName}</p>
                         
                        </div>
                        <div style={{display:"flex",alignItems:"start",justifyContent:"left",gap:"20px"}}>
                        <p>Total: {item.totalPrice}</p>
                        <p>Sale Price: {item.salePrice}</p>
                        <p>Quantity: {item.quantity}</p>
                        </div>
                      
                      </div>
                    ))
                  }

                </div>

              </div>
            }
       
            </div>

            
            
        </div>
    )

}
const WishlistHistory=()=>{
  const [wishlist, setWishlist] = useState([])

  const fetchWishlist=async()=>{
  try {
    const response=await getWishlist()
    console.log("Wishlist Data:", response);
    setWishlist(response.data || []);
    
  } catch (error) {
    console.log("Error fetching wishlist data:", error);
    
  }
}

useEffect(() => {
  fetchWishlist()
}, [])

  const timeConvert=(timestamps)=>{
    const date = new Date(timestamps);

// Format to readable string
const readableDate = date.toLocaleString();

return readableDate
   }


    return(
        <div>
            <h1 className='text-md'>View your wishlist history</h1>

            <div className='w-full h-[560px] overflow-auto p-4 flex flex-wrap items-start justify-start gap-2 shadow-lg mb-2 rounded-md'>
       

         {
                                wishlist.length>0?
                                wishlist.map((item,index)=>(
                                <ProductCard img={item.productImage} price={item.retailSalePrice} 
                                rate={item.retailSaleRate}
                                  id={item.productId}
                                description={" Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod te incididunt"}
                                 name={item.productName} stock={item.stock} type={item.bookingTypeId}/>
                                )):
                                <p>Failed to get products</p>
                              }
            </div>

            
        </div>
    )

}

const CustomizedHistory=()=>{

    const  ORDER_STATUSES = [
     " PENDING",
       "APPROVED",
        "ASSIGNED",
        "IN_PROGRESS",
        "COMPLETED",
        'CANCELLED', 
        "DATA_UPLOADED"
];

const[mobile,setmobile]=useState(window.innerWidth<560)

const OrderTracking = ({ currentStatus }) => {
  const currentIndex = ORDER_STATUSES.indexOf(currentStatus);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        maxWidth: "400px",
        margin: "auto"
      }}
    >
      {ORDER_STATUSES.map((status, index) => {
        const isCompleted = index < currentIndex;
        const isActive = index === currentIndex;

        return (
          <div
            key={status}
            style={{
              display: "flex",
              alignItems: "flex-start",
              position: "relative",
              minHeight: "70px"
            }}
          >
            {/* Left Indicator */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginRight: "16px"
              }}
            >
              {/* Circle */}
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: isCompleted
                    ? "#28a745"
                    : isActive
                    ? "#007bff"
                    : "#cccccc",
                  color: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold"
                }}
              >
                {isCompleted ? "✓" : index + 1}
              </div>

              {/* Vertical Line */}
              {index !== ORDER_STATUSES.length - 1 && (
                <div
                  style={{
                    width: "4px",
                    flex: 1,
                    backgroundColor: isCompleted ? "#28a745" : "#cccccc",
                    marginTop: "4px"
                  }}
                />
              )}
            </div>

            {/* Status Text */}
            <div
              style={{
                paddingTop: "6px"
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: isActive ? "600" : "400"
                }}
              >
                {status}
              </div>

              <div
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  marginTop: "4px"
                }}
              >
                {isCompleted
                  ? "Completed"
                  : isActive
                  ? "In Progress"
                  : "Pending"}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};



  const [wishlist, setWishlist] = useState([])
     const [viewModal,setViewModal]=useState(null)
  const[hover,setHover]=useState(-1)
  const [allProducts,setAllProducts]=useState([])
  const[currentReport,setCurrentReport]=useState(null)
  const [reportModal,setReportModal]=useState(false)
  const[reportGraph,setReportGraph]=useState(null)
  const[currentOrder,setCurrentOrder]=useState(null)
  const[audiometerDetails,setaudiometerDetails]=useState(null)
  const[patientData,setPatientData]=useState(null)

   const fetchAllProducts=async()=>{
      try {
        const response = await getProducts()
        console.log(response.data);
  
  
        setAllProducts((response.data))
  
        
  
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    }

  const fetchWishlist=async()=>{
  try {
    const response=await getCustomizedBooking()
    console.log("customized Data:", response.data);
    
      setWishlist(response.data );
   
    
    
  } catch (error) {
    console.log("Error fetching wishlist data:", error);
    
  }
}

const getReportData=async(id)=>{
  try {
    const res= await getCustomizeTestReport(id)
    console.log(res);
    if(res.status===200){
      setReportModal(true)
      setaudiometerDetails(res.data.audiometerDetails)
      setCurrentReport(res.data.sections||[])
      setReportGraph(JSON.parse(res.data.sections[0].subsections[7].answers[0].graphDataJson||null))
      console.log(JSON.parse(res.data.sections[0].subsections[7].answers[0].graphDataJson));
      
    }
    
  } catch (error) {
    console.log(error);
    
  }
}

const handleUserDetails=async()=>{
  try {
      const response=await getProfile()
      console.log('handleUserDetails',response);
      setPatientData(response.data.data.patientdto)
      
  } catch (error) {
    console.log(error);
    
  }
}

useEffect(() => {
  fetchWishlist()
  fetchAllProducts()
  handleUserDetails()
}, [])

  const timeConvert=(timestamps)=>{
    const date = new Date(timestamps);

// Format to readable string
const readableDate = date.toLocaleString();

return readableDate
   }



const downloadPDF = async () => {
  const element = document.getElementById("pdf-content");

  const canvas = await html2canvas(element, {
    scale: 2,               // 🔥 high quality
    useCORS: true,          // 🔥 external images
    backgroundColor: "#fff"
  });

  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("p", "mm", "a4");

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight =
    (canvas.height * pdfWidth) / canvas.width;

  pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  pdf.save("report.pdf");
};


    return(
        <div>
            <h1 className='text-md'>View your Customized booking  history</h1>

              <div className='w-full h-[460px]  p-1 flex flex-wrap items-start justify-start gap-6 shadow-lg mb-2 rounded-md'
            style={{overflowY:"auto",overflowX:"visible"}}
            >
     
          <table   className="table table-hover table-vcenter table-striped mb-0 text-nowrap"
          >
      
          <thead>
            <tr >
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Id</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Total paid</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Date</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Buyer Name</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Grand Total</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Pickup Location</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Product Name</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Quantity</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>Report</th>
            <th style={{textAlign:"center",border:"0.3px solid black",backgroundColor:"#178dfcff",color:'white'}}>View</th>
          </tr>
          </thead>
          <tbody>
            {
             wishlist.length>0 && wishlist.map((item,indx)=>(
              <tr key={indx}
               className='hover:bg-gray'
              style={{padding:"4px", transition: "transform 0.2s ease-in-out",color:"black",
                zIndex:999,cursor:"pointer",border:"0.3px solid black",minWidth:"fit-content",
              backgroundColor:hover===indx?"#8f8e8eff":"#fefefe",color:hover===indx?"white":"black"
              }}
                 onMouseEnter={e => {(e.currentTarget.style.transform = "scale(1.01)"); setHover(indx)}}
           onMouseLeave={e => {(e.currentTarget.style.transform = "scale(1)");setHover(-1)}}
              >
              <th style={{textAlign:"center",maxWidth:"100px",overflow:"auto",border:"0.3px solid black"}}>{indx+1}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>₹{item.grandTotal}</th>
              <th style={{textAlign:"center",maxWidth:"170px",overflow:"hidden",border:"0.3px solid black"}}>{timeConvert(item.createdAt)}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.buyerName}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>₹{item.grandTotal}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.pickupLocation}</th>
              <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.productName}</th>
               <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>{item.quantity}</th>
               <th style={{textAlign:"center",maxWidth:"130px",overflow:"hidden",border:"0.3px solid black"}}>
                <img src='/Assets/img/report.png' style={{width:"18px"}}
                onClick={()=>{getReportData(item.id);setCurrentOrder(item)}}
                />
               </th>
              <th style={{textAlign:"center", blackmaxWidth:"130px",overflow:"hidden"}}>
                <img src='/Assets/img/eye.png' style={{width:"18px"}}
                onClick={()=>setViewModal(item)}
                />
                </th>
            </tr>
              ))
            }
           
          </tbody>
       
       </table>
       {
              viewModal &&
              <div style={{width:mobile?"350px":"550px",borderCollapse: "collapse",border:"1px solid gray",backgroundColor:'white',borderRadius:"10px",padding:"10px"
          ,boxShadow: "0 2px 8px rgba(0,0,0,0.1)",position:"absolute",top:"200px",right:"10vw",zIndex:99999,color:"black",}}>
                <p style={{display:"flex",justifyContent:"space-between",width:"100%"}}>
                 
                </p>
                <span onClick={()=>setViewModal(null)}
                    style={{cursor:"pointer",right:"20px",position:"absolute"}}
                    >X</span>

               <OrderTracking currentStatus={viewModal.customizedRequestStatus} />

              </div>
            }

            {
              reportModal &&
                 <div style={{width:mobile?"90vw":"850px",borderCollapse: "collapse",border:"1px solid gray",backgroundColor:'white',borderRadius:"10px",padding:"10px"
          ,boxShadow: "0 2px 8px rgba(0,0,0,0.1)",position:"absolute",top:"200px",right:"10vw",zIndex:99999,color:"black",height:"96vh",overflowY:"auto"}}>
               <span onClick={()=>setReportModal(false)}
                    style={{cursor:"pointer",right:"20px",position:"absolute",top:"10px",backgroundColor:"#dbdada",padding:"10px",borderRadius:"50%"}}
                    >X</span>
                    <p style={{fontSize:"20px",fontWeight:"600"}}>Download Three pages below  (one by one)</p>

                    <div
                     id="pdf-content"
                    style={{padding:"20px",border:"2px solid grey",borderRadius:"16px"}}>

                      Page 1
                      <img src='/Assets/img/download.png' style={{width:"18px"}}
                        onClick={downloadPDF}/>
                    <div style={{padding:"30px 10px"}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",border:"1px solid black",padding:"10px"}}>
                        <div>
                          <p style={{fontSize:"18px",fontWeight:"700"}}>AudiBle</p>
                          <p style={{fontSize:"16px",fontWeight:"600"}}>H.O.Shimurali,Nadia,WB,Helpline +91 7797 800 555</p>
                        </div>
                        <div>
                           <img src="Assets/LogoRndsan.jpeg" width="100px" />
                        </div>

                      </div>

                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",fontSize:"14px",border:"1px solid black",padding:"10px"}}>
                        <div>
                          <p style={{margin:0,fontWeight:"600"}}>Patient Name<span style={{fontWeight:"400",paddingLeft:"20px"}}> {currentOrder.buyerName}</span></p>
                          <p style={{margin:0,fontWeight:"600"}}>Client No<span style={{fontWeight:"400",paddingLeft:"20px"}}>0015692</span> </p>
                          <p style={{margin:0,fontWeight:"600"}}>Bill No <span style={{fontWeight:"400",paddingLeft:"20px"}}>{currentOrder.productName}</span></p>
                          <p style={{margin:0,fontWeight:"600"}}>Address <span style={{fontWeight:"400",paddingLeft:"20px"}}>{currentOrder.pickupLocation}</span></p>
                         

                        </div>
                        <div>
                          <p style={{margin:0,fontWeight:"600"}}>Date of Birth <span style={{fontWeight:"400",paddingLeft:"20px"}}> 01-05-1996</span></p>
                          <p style={{margin:0,fontWeight:"600"}}>Doctor <span style={{fontWeight:"400",paddingLeft:"20px"}}> Dr. Decraj Pal</span></p>
                          <p style={{margin:0,fontWeight:"600"}}>KYC <span style={{fontWeight:"400",paddingLeft:"20px"}}>Not provided</span></p>
                        </div>

                      </div>
                     <p style={{fontSize:"14px"}}> Test date:   {timeConvert(currentOrder.createdAt)}</p>
                      </div>

                     <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
      <Graph
        title=""
        data={reportGraph.right}
        color="red"
      />
      <div>
        <p>x{"-->"} Bc</p>
         <p><span style={{fontSize:"50px",fontWeight:"700",borderRadius:"50%"}}>.</span>
          {"-->"} Ac</p>
      </div>

      <Graph
        title=""
        data={reportGraph.left}
        color="blue"
      />
                     </div>

                     <div style={{padding:"14px",border:"1px solid black",fontSize:"12px"}}>
                      <p style={{margin:0,fontWeight:"600"}}>Report comments:</p>
                      <p style={{margin:0}}>Report Comments:</p>
                      <p style={{margin:0}}>Audiometer Used:</p>
                             <div style={{paddingLeft:"40px"}}>
                              <p style={{margin:0}}>Company : {audiometerDetails.companyName}</p>
                              <p style={{margin:0}}>Type : {audiometerDetails.model}</p>
                              <p style={{margin:0}}>Type:{audiometerDetails.type}</p>
                              <p style={{margin:0}}>Serial No: {audiometerDetails.serialNumber}</p>
                              <p style={{margin:0}}>AC Headphone:{audiometerDetails.acHeadPhone}</p>
                              <p style={{margin:0}}>BC Vibrator:{audiometerDetails.bcVibrator}</p>
                              <p style={{margin:0}}>Calibrated On: See Report Page</p>
                             </div>
                      <p style={{margin:0}}>Test Protocol:</p>
                      <p style={{margin:0}}> Completely sujective test ,Method follow for audiometry is 5up 10down with proper masking for both AC and BC as per James Jerger,Northwestren University</p>
                      <p style={{margin:0}}>Environment:</p>
                      <p style={{margin:0}}>Calm and quiet,good for Audiological Evaluation</p>
                      </div>

                      <div style={{padding:"14px",border:"1px solid black",fontSize:"12px",display:"flex",justifyContent:"space-between"}}>
                        <div>
                          <p style={{margin:0}}>Name</p>
                          <p style={{margin:0}}>AudiBle</p>
                        </div>
                        <p style={{fontSize:"14px"}}> Test date:   {timeConvert(currentOrder.createdAt)}</p>
                        </div>
                    </div>


                     <div
                     id="pdf-content"
                    style={{padding:"20px",border:"2px solid grey",borderRadius:"16px"}}>
                      <div style={{display:"flex",justifyContent:"space-between"}}>
                        <div>
                          <p>Test center Address</p>
                          <p>Chakdah</p>
                        </div>
                         <div>
                           <img src="Assets/LogoRndsan.jpeg" width="100px" />
                        </div>

                      </div>

                      <div style={{display:"flex",justifyContent:"space-between",border:"1px solid black",fontSize:"14px",padding:"14px"}}>
                        <div >
                          <p style={{margin:0}}>Name  {patientData.firstName} {patientData.lastName}</p>
                          <p style={{margin:0}}>Address  {patientData.streetRoadLane}</p>
                          <p style={{margin:0}}>City  {patientData.villageTownCity}</p>
                          <p style={{margin:0}}>KYC  Not provided</p>
                          <p style={{margin:0}}>Doctor   Dr. devraj Pal</p>

                        </div>
                        <div style={{display:"flex",borderLeft:"1px solid grey"}}>
                          <img src=''/>
                          <div>
                            <p style={{margin:0}}>Date</p>
                            <p style={{margin:0}}>Age</p>
                            <p style={{margin:0}}>Gender  {patientData.gender}</p>
                            <p style={{margin:0}}>CL ID {1234}</p>
                            <p style={{margin:0}}>Bill No  26/0452</p>
                          </div>

                        </div>

                      </div>

                      <div style={{border:"1px solid black",padding:"14px"}}>

                      </div>


                      </div>
            </div>
              
            }
       
            </div>

            
        </div>
    )

}

const Profile = () => {

     const token = JSON.parse(Cookies.get('loginData'))
   const navigate = useNavigate();
   const[mobile,setMoble]=useState(window.innerWidth<568)
   const [filter,setFilter]=useState(false)

  const ref=() => {
    if(!token){
      navigate("/login")
      return
    }
    
  }
  useEffect(() => {
   ref()
  }, [])


const[section,setSection] = useState("profile")

const handelLogout=()=>{
  try {
     Cookies.remove("loginData");
     navigate("/login")
     toast.success("Signed out !")
    
  } catch (error) {
    console.log(error);
    
  }
}




  return (
    <div className='w-full h-screen flex flex-col items-center justify-between'>
       <Header/>
        <div className='w-full min-h-[100vh] bg-gray-100 pt-[140px] flex flex-col items-center justify-between sm:flex-row'> 
         {!mobile&& <div style={{width:mobile?"50%":"250px"}}
          className='w-[250px] h-full  p-4  flex oerflow-auto sm:flex-col gap-1 ml-6'>
           
            <p className='text-gray-600 text-xl'>Welcome to your profile!</p>
            <p className='text-lg font-semibold'>View History</p>
            <p onClick={()=>setSection("orders")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Orders</p>
             <p onClick={()=>setSection("service-history")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Service History</p>
            <p onClick={()=>setSection("customized")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Customized Booking</p>
             <p onClick={()=>setSection("wishlist")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Wishlist</p>
            <p className='text-lg font-semibold'>View & Edit profile</p>
           <p  onClick={()=>setSection("profile")}  className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Profile</p>
            <p className='text-lg font-semibold'>Others</p>
            <p onClick={()=>setSection("settings")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Settings</p>
            <p className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'
            onClick={handelLogout}
            >
              Sign Out</p>
            <p></p>
          </div>}
         {filter&& 
         <div style={{width:mobile?"50%":"250px",position:"fixed",zIndex:9999,left:"10px",top:"20px",padding:"10px",backgroundColor:"white",borderRadius:"10px",boxShadow: "0 2px 8px rgba(0,0,0,0.1)"}}
        >
           <p style={{position:"absolute",right:"10px",top:"5px",cursor:"pointer"}}
           onClick={()=>setFilter(false)}>X</p>
           
            <p className='text-lg font-semibold'>View History</p>
            <p onClick={()=>setSection("orders")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Orders</p>
             <p onClick={()=>setSection("service-history")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Service History</p>
            <p onClick={()=>setSection("customized")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Customized Booking</p>
             <p onClick={()=>setSection("wishlist")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Wishlist</p>
            <p className='text-lg font-semibold'>View & Edit profile</p>
           <p  onClick={()=>setSection("profile")}  className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Profile</p>
            <p className='text-lg font-semibold'>Others</p>
            <p onClick={()=>setSection("settings")} className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'>Settings</p>
            <p className='p-2 rounded-md shadow-lg w-full text-center cursor-pointer hover:bg-gradient-to-r hover:from-green-300 hover:to-blue-400 hover:text-white'
            onClick={handelLogout}
            >
              Sign Out</p>
            <p></p>
          </div>}
          <div className='w-[calc(100%-250px)]  p-4 flex flex-col items-center'
          style={{height:"fit-content",width:mobile?"100%":"calc(100%-250px)"}}
          >
          {mobile&&
          
          <p onClick={()=>setFilter(!filter)}
              style={{position:"fixed",left:"20px",top:"80px"}}>
              <img src='/Assets/menu-bar.png'/>
            </p>}

           <div style={{width:"100%"}}>
             {
                section === "profile" ?<Editprofile/>:
                section === "orders" ? <OrderHistory/> :
                section === "service-history" ? <ServiceHistory/> :
                  section === "customized" ? <CustomizedHistory/> :
                 section === "wishlist" ? <WishlistHistory/> :
                section === "settings" ? "settings" :
                "other section"
            }</div>
          </div>
        </div>

       
        <div className='w-full'>
            <Footer/>
            </div>
    </div>
  )
}



const Graph = ({ title, data, color = "blue" }) => {
  const width = 300;
  const height = 300;
  const padding = 50;

  const xAllowed = [125, 250, 500, 1000, 2000, 4000, 8000];
  const yMin = -10;
  const yMax = 120;

  const xScale = (x) =>
    padding +
    (xAllowed.indexOf(x) / (xAllowed.length - 1)) * (width - padding * 2);

  const yScale = (y) =>
    padding + ((y - yMin) / (yMax - yMin)) * (height - padding * 2);

  // --- AC Logic (Connected Line + Circles) ---
  let acPath = "";
  data.x.forEach((xVal, i) => {
    const yVal = data.ac[i];
    if (xAllowed.includes(xVal) && yVal != null) {
      const x = xScale(xVal);
      const y = yScale(yVal);
      acPath += acPath === "" ? `M ${x} ${y}` : ` L ${x} ${y}`;
    }
  });

  // --- BC Logic (X Mark Component) ---
  const RenderXMark = ({ x, y, size = 5 }) => (
    <g stroke={color} strokeWidth="2">
      <line x1={x - size} y1={y - size} x2={x + size} y2={y + size} />
      <line x1={x + size} y1={y - size} x2={x - size} y2={y + size} />
    </g>
  );

  return (
    <div style={{ marginBottom: 40, fontFamily: "sans-serif" }}>
      <h3 style={{ textAlign: "center" }}>{title}</h3>

      <svg width={width} height={height} style={{ border: "1px solid #ccc", overflow: "visible" }}>
        {/* Y Grid */}
        {Array.from({ length: 14 }, (_, i) => {
          const yValue = yMin + i * 10;
          const y = yScale(yValue);
          return (
            <g key={yValue}>
              <line x1={padding} x2={width - padding} y1={y} y2={y} stroke="#e0e0e0" />
              <text x={padding - 10} y={y + 4} fontSize="10" textAnchor="end">{yValue}</text>
            </g>
          );
        })}

        {/* X Labels */}
        {xAllowed.map((xVal) => (
          <text key={xVal} x={xScale(xVal)} y={padding - 15} fontSize="10" textAnchor="middle">
            {xVal >= 1000 ? `${xVal / 1000}k` : xVal}
          </text>
        ))}

        {/* Axes */}
        <line x1={padding} y1={padding} x2={padding} y2={height - padding} stroke="black" />
        <line x1={padding} y1={height - padding} x2={width - padding} y2={height - padding} stroke="black" />

        {/* 1. AC DATA: Line and Circles */}
        <path d={acPath} fill="none" stroke={color} strokeWidth="2" />
        {data.x.map((xVal, i) => (
          xAllowed.includes(xVal) && data.ac[i] != null ? (
            <circle key={`ac-dot-${i}`} cx={xScale(xVal)} cy={yScale(data.ac[i])} r="4" fill={color} />
          ) : null
        ))}

        {/* 2. BC DATA: X Marks Only */}
        {data.x.map((xVal, i) => (
          xAllowed.includes(xVal) && data.bc[i] != null ? (
            <RenderXMark key={`bc-x-${i}`} x={xScale(xVal)} y={yScale(data.bc[i])} />
          ) : null
        ))}
      </svg>
    </div>
  );
};

export default Profile